var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"pageView",staticClass:"page-view"},[_c('application-content-detail',{ref:"applicationContent",attrs:{"pageType":"examine"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }